module.exports = __webpack_public_path__ + "static/media/C_J.1f52a187.png";